import { render, staticRenderFns } from "./DatosAdjuntos.vue?vue&type=template&id=8adba3e4&scoped=true&"
import script from "./DatosAdjuntos.vue?vue&type=script&lang=js&"
export * from "./DatosAdjuntos.vue?vue&type=script&lang=js&"
import style0 from "./DatosAdjuntos.vue?vue&type=style&index=0&id=8adba3e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adba3e4",
  null
  
)

export default component.exports